module.exports = __webpack_public_path__ + "img/blue-good.e342e7e5.svg";